import { render, staticRenderFns } from "./ImportEmployee.vue?vue&type=template&id=00c546d2"
import script from "./ImportEmployee.vue?vue&type=script&lang=js"
export * from "./ImportEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports